export default __webpack_public_path__ + "static/media/l2.7dc11a67.png";